import { render, staticRenderFns } from "./ReportProblemDialog.vue?vue&type=template&id=45304358"
import script from "./ReportProblemDialog.vue?vue&type=script&lang=js"
export * from "./ReportProblemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports